module.exports = __webpack_public_path__ + "media/images/powered_by_stripe-193cb2ad26d440ae2a91d3fd6bd22547.png";